import type { Environment } from '../../api';

const ENVIRONMENT_STORAGE_PREFIX = 'co.project.';

export function rememberedEnvironment(projectId: string): string | null {
  try {
    return window.localStorage.getItem(`${ENVIRONMENT_STORAGE_PREFIX}${projectId}.environment`);
  } catch {
    return null;
  }
}

export function rememberEnvironment(projectId: string, environmentId: string) {
  try {
    window.localStorage.setItem(`${ENVIRONMENT_STORAGE_PREFIX}${projectId}.environment`, environmentId);
  } catch {
    // A per-viewer convenience only; the URL carries the real context.
  }
}

/**
 * resolveEnvironment picks the environment a URL means. The slug is what
 * `?env=` carries so a link stays readable and survives a rebuild of the
 * environment record; an id is still accepted because older links and the
 * remembered choice use one.
 */
export function resolveEnvironment(environments: Environment[], wanted: string | null): Environment | null {
  if (environments.length === 0) return null;
  if (wanted) {
    const bySlug = environments.find((environment) => environment.slug === wanted);
    if (bySlug) return bySlug;
    const byId = environments.find((environment) => environment.id === wanted);
    if (byId) return byId;
  }
  return environments.find((environment) => environment.kind === 'production') ?? environments[0]!;
}
